import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty, trim } from 'lodash';
import { withTranslation } from 'react-i18next';

class Settings extends React.Component {
  static propTypes = {
    onUpdate: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = { currentPassword: '', password: '', passwordConfirmation: '' };
  }

  onChange = (e) => this.setState({[e.target.name]: e.target.value})

  onUpdate = () => {
    this.props.onUpdate(this.state);
  }

  render() {
    const { currentPassword, password, passwordConfirmation } = this.state;
    const clsUpdate = classNames('o-sp-button o-sp-button--update o-sp-button--primary',
      { 'u-disabled': isEmpty(trim(currentPassword)) || isEmpty(trim(password)) || isEmpty(trim(passwordConfirmation)) }
    );
    return (
      <div className='u-margin-top--base'>
        <p>
          <span className='u-txt--label'>{this.props.t('settings.currentPassword')}</span><br/>
          <input name='currentPassword' type='password' value={currentPassword} onChange={this.onChange}/>
        </p>
        <p>
          <span className='u-txt--label'>{this.props.t('settings.newPassword')}</span><br/>
          <input name='password' type='password' value={password} onChange={this.onChange}/>
        </p>
        <p>
          <span className='u-txt--label'>{this.props.t('settings.confirmNewPassword')}</span><br/>
          <input name='passwordConfirmation' type='password' value={passwordConfirmation} onChange={this.onChange}/>
        </p>
        <div className='text-right'>
          <a className={clsUpdate} onClick={this.onUpdate}>{this.props.t('settings.changePassword')}</a>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Settings);
